import Http from "../http";

class ExcludedZoneServices {
    static async getExcludedZones(){
        return Http.get('/getExcludeZones')
    }
    static async updateExcludedZone(id,cityData){
        return Http.update(`/editingcity/${id}`,cityData)
    }
    static async addExcludeZone(cityData){
        return Http.post(`/addExcludeZone`,cityData)
    }
    static async deleteExcludeZone(id){
        return Http.delete(`/deleteCity/${id}`)
    }

}
export default ExcludedZoneServices